import styled from '@emotion/styled'
import { Primary, subheader, caption } from '@sphinx/components-styles'

export const Headline = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 35px;
  justify-content: space-between;
`

export const HeadlineText = styled.h1`
  ${subheader};
`

export const Label = styled.label`
  ${caption};
  color: ${Primary.navy[100]};
  font-weight: 600;
  margin-bottom: 6px;
`

export const Field = styled.div`
  margin-bottom: 12px;
`

export const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-top: 12px;

  & > button:first-of-type {
    margin-right: 6px;
  }
`
